module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-container', [_c('h1', {
    staticClass: "text-xs-center headline font-weight-regular"
  }, [_vm._v("\n                Atualização de Dados Cadastrais\n            ")]), _vm._v(" "), _c('v-form', {
    attrs: {
      "color": "vestibular-primary"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('h2', {
    staticClass: "title pb-1"
  }, [_vm._v("Dados Pessoais")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Completo",
      "error-messages": _vm.nomeErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.nome.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.nome.$touch()
      }
    },
    model: {
      value: (_vm.data.nome),
      callback: function($$v) {
        _vm.$set(_vm.data, "nome", $$v)
      },
      expression: "data.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "error-messages": _vm.emailErros,
      "color": "amber darken-3",
      "outline": "",
      "disabled": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.email.$touch()
      }
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(##) #####.####'),
      expression: "'(##) #####.####'"
    }],
    attrs: {
      "label": "Telefone",
      "error-messages": _vm.telefoneErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.telefone.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.telefone.$touch()
      }
    },
    model: {
      value: (_vm.data.telefone),
      callback: function($$v) {
        _vm.$set(_vm.data, "telefone", $$v)
      },
      expression: "data.telefone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.sexos,
      "label": "Sexo",
      "error-messages": _vm.sexoErros,
      "item-value": "sigla",
      "item-text": "nome",
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.sexo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.sexo.$touch()
      }
    },
    model: {
      value: (_vm.data.sexo),
      callback: function($$v) {
        _vm.$set(_vm.data, "sexo", $$v)
      },
      expression: "data.sexo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-menu', {
    ref: "datepickerDataNascimento",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.mostrarDatepickerDataNascimento),
      callback: function($$v) {
        _vm.mostrarDatepickerDataNascimento = $$v
      },
      expression: "mostrarDatepickerDataNascimento"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    attrs: {
      "slot": "activator",
      "label": "Data de Nascimento",
      "persistent-hint": "",
      "required": "",
      "color": "amber darken-3",
      "outline": "",
      "box": ""
    },
    on: {
      "blur": function($event) {
        _vm.data.data_nascimento = _vm.dateFormat(_vm.data.data_nascimento_formatada, 'en')
      }
    },
    slot: "activator",
    model: {
      value: (_vm.data.data_nascimento_formatada),
      callback: function($$v) {
        _vm.$set(_vm.data, "data_nascimento_formatada", $$v)
      },
      expression: "data.data_nascimento_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br"
    },
    on: {
      "input": function($event) {
        _vm.mostrarDatepickerDataNascimento = false
      }
    },
    model: {
      value: (_vm.data.data_nascimento),
      callback: function($$v) {
        _vm.$set(_vm.data, "data_nascimento", $$v)
      },
      expression: "data.data_nascimento"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF",
      "error-messages": _vm.cpfErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.cpf_cnpj.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.cpf_cnpj.$touch()
      }
    },
    model: {
      value: (_vm.data.cpf_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.data, "cpf_cnpj", $$v)
      },
      expression: "data.cpf_cnpj"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "RG",
      "error-messages": _vm.rgErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.rg.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.rg.$touch()
      }
    },
    model: {
      value: (_vm.data.rg),
      callback: function($$v) {
        _vm.$set(_vm.data, "rg", $$v)
      },
      expression: "data.rg"
    }
  })], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "title pb-1"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#####-###'),
      expression: "'#####-###'"
    }],
    attrs: {
      "label": "CEP",
      "error-messages": _vm.cepErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.cep.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.cep.$touch()
      }
    },
    model: {
      value: (_vm.data.cep),
      callback: function($$v) {
        _vm.$set(_vm.data, "cep", $$v)
      },
      expression: "data.cep"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.ruaErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "label": "Rua"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.rua.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.rua.$touch()
      }
    },
    model: {
      value: (_vm.data.rua),
      callback: function($$v) {
        _vm.$set(_vm.data, "rua", $$v)
      },
      expression: "data.rua"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "dataNumero",
    attrs: {
      "error-messages": _vm.numeroErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "label": "Número"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.numero.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.numero.$touch()
      }
    },
    model: {
      value: (_vm.data.numero),
      callback: function($$v) {
        _vm.$set(_vm.data, "numero", $$v)
      },
      expression: "data.numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.bairroErros,
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "label": "Bairro"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.bairro.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.bairro.$touch()
      }
    },
    model: {
      value: (_vm.data.bairro),
      callback: function($$v) {
        _vm.$set(_vm.data, "bairro", $$v)
      },
      expression: "data.bairro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "label": "Complemento"
    },
    model: {
      value: (_vm.data.complemento),
      callback: function($$v) {
        _vm.$set(_vm.data, "complemento", $$v)
      },
      expression: "data.complemento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "error-messages": _vm.refEstadoErros,
      "items": _vm.dependencias.estados,
      "item-text": "nome",
      "item-value": "id",
      "label": "Estado",
      "placeholder": "Selecione o estado",
      "no-data-text": "Nenhuma registro encontrado",
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "hide-no-data": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.ref_estado.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.ref_estado.$touch()
      }
    },
    model: {
      value: (_vm.data.ref_estado),
      callback: function($$v) {
        _vm.$set(_vm.data, "ref_estado", $$v)
      },
      expression: "data.ref_estado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "error-messages": _vm.refCidadeErros,
      "disabled": !_vm.data.ref_estado,
      "items": _vm.dependencias.cidades,
      "loading": _vm.buscandoCidades,
      "search-input": _vm.buscarCidade,
      "item-text": "nome",
      "item-value": "id",
      "label": "Cidade",
      "placeholder": "Digite o nome da cidade",
      "no-data-text": "Nenhuma registro encontrado",
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "hide-no-data": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.ref_cidade.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.ref_cidade.$touch()
      },
      "update:searchInput": function($event) {
        _vm.buscarCidade = $event
      },
      "update:search-input": function($event) {
        _vm.buscarCidade = $event
      }
    },
    model: {
      value: (_vm.data.ref_cidade),
      callback: function($$v) {
        _vm.$set(_vm.data, "ref_cidade", $$v)
      },
      expression: "data.ref_cidade"
    }
  })], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "title pb-1"
  }, [_vm._v("Dependentes")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-1"
  }), _vm._v(" "), _c('v-list', {
    staticClass: "mb-4",
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.data.dependentes), function(item, index) {
    return [_c('v-list-tile', {
      key: item.title,
      staticClass: "elevation-1"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.nome))])], 1)], 1)]
  })], 2), _vm._v(" "), _c('h2', {
    staticClass: "title pb-1"
  }, [_vm._v("Financeiro")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-1"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Autorizo a rematrícula automática",
      "color": "amber darken-3",
      "type": "checkbox"
    },
    model: {
      value: (_vm.data.fl_matricula_automatica),
      callback: function($$v) {
        _vm.$set(_vm.data, "fl_matricula_automatica", $$v)
      },
      expression: "data.fl_matricula_automatica"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.meses,
      "label": "Mês do 1º Pagamento",
      "error-messages": _vm.mesPagamentoErros,
      "item-value": "mes",
      "item-text": "nome",
      "color": "amber darken-3",
      "outline": "",
      "box": "",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.mes_pagamento.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.mes_pagamento.$touch()
      }
    },
    model: {
      value: (_vm.data.mes_pagamento),
      callback: function($$v) {
        _vm.$set(_vm.data, "mes_pagamento", $$v)
      },
      expression: "data.mes_pagamento"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btn",
    attrs: {
      "color": "success",
      "block": "",
      "large": "",
      "disabled": _vm.botaoClicado || _vm.$v.data.$invalid || !_vm.hashValido
    },
    on: {
      "click": function($event) {
        return _vm.salvarDados()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Salvar Dados")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "box-dados-cadastrais",
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "flex-logo"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "https://urcamp.edu.br/site/img/logos/logo-branco.png",
      "alt": ""
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5762fa54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/AtualizacaoDados.vue
// module id = 546
// module chunks = 2